import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { inject } from "mobx-react";

import type { Store } from "@inferno/renderer-shared-core";
import "./ContentFooter.style.scss";
import { MagicLink } from "../../ui";

interface ContentFooterProps {
  author?: string;
  feedType?: string | null;
  fallBackUrl?: string;
  siteName?: string | null;
  store?: Store;
  type: string;
  url?: string;
}

const ContentFooter = inject("store")((props: ContentFooterProps) => {
  if (!props?.store) {
    return null;
  }

  const { t } = useTranslation();
  const { siteName, author } = props;
  // if type is partner and both author and sitename not defined
  if (props.type === "partner" && !author && !siteName) {
    return null;
  }
  const footerClass = classnames("component-sponsor-footer", {
    [`${props.type}`]: props.type,
  });

  let footerText = "";
  let url = props.url;
  if (props.type === "sponsored") {
    footerText = author ? t("sponsored_footer", { author, siteName }) : t("sponsored_footer_no_author", { siteName });
  } else if (props.feedType?.toLowerCase() === "podcast") {
    footerText = t("partner_podcast_footer");
    url = props.url ? props.url + "?pname=podcastarticle" : props.fallBackUrl || props.store.env.NATIONAL_SITE_URL;
  } else if (props.type === "partner") {
    footerText = t("partner_footer");
  }

  return (
    <div className={footerClass}>
      <span className="footer-disclosure">
        {footerText}{" "}
        {props.type === "partner" ? (
          url ? (
            <MagicLink to={url} external={true}>
              {siteName}
            </MagicLink>
          ) : (
            siteName
          )
        ) : null}
      </span>
    </div>
  );
});

export default ContentFooter;
